import apiWrapper from 'Helpers/apiWrapper'
import { encodeParams } from 'mailup-react-helpers'
// import extractApiData from 'Helpers/extractApiData'

const endpoints = (baseURL => {
  return {
    //  Authorize
    authorizeBee: page => `${baseURL}/authorize/${page}`,
    //
    addSavedRow: idList => `${baseURL}/api/list/${idList}/savedrows`,
    getSavedRows: (idList, idCategory) =>
      `${baseURL}/api/list/${idList}/savedrows?${encodeParams({
        idCategory
      })}`,
    getSavedRow: (idList, idSavedRow) =>
      `${baseURL}/api/list/${idList}/savedrows/${idSavedRow}`,
    deleteSavedRows: (idList, idSavedRow) =>
      `${baseURL}/api/list/${idList}/savedrows/${idSavedRow}`,
    updateSavedRows: (idList, idSavedRow) =>
      `${baseURL}/api/list/${idList}/savedrows/${idSavedRow}`,
    countSavedRows: (idList, idCategory) =>
      `${baseURL}/api/list/${idList}/savedrows/count?${encodeParams({
        idCategory
      })}`,
    saveContentDefaults: idList =>
      `${baseURL}/api/list/${idList}/contentdefaults/save`,
    getContentDefaults: idList =>
      `${baseURL}/api/list/${idList}/contentdefaults`,
    enabledContentDefaults: idList =>
      `${baseURL}/api/list/${idList}/contentdefaults/enable`,
    getUsedTokens: `${baseURL}/api/aiassistant/usedtokens`,
    storeUsedTokens: `${baseURL}/api/aiassistant/usedtokens`
  }
})(process.env.BEBEESERVICE_URL)

export const beBeeServiceGetUsedTokens = () => {
  return apiWrapper({
    method: 'get',
    url: endpoints.getUsedTokens
  }).then(res => res.data)
}

export const beBeeServiceStoreUsedTokens = value => {
  return apiWrapper({
    method: 'put',
    url: endpoints.storeUsedTokens,
    data: JSON.stringify({ UsedTokens: value })
  }).then(res => res.data)
}

export const beBeeServiceEnabledContentDefaults = (idList, data) => {
  const url = endpoints.enabledContentDefaults(idList)

  return apiWrapper({
    method: 'put',
    url: url,
    data: JSON.stringify(data)
  }).then(res => res.data)
}

export const beBeeServiceGetContentDefaults = idList => {
  const url = endpoints.getContentDefaults(idList)

  return apiWrapper({
    method: 'get',
    url: url
  }).then(res => res.data)
}

export const beBeeServiceSaveContentDefaults = (idList, data) => {
  const url = endpoints.saveContentDefaults(idList)

  return apiWrapper({
    method: 'post',
    url: url,
    data: JSON.stringify(data)
  }).then(res => res.data)
}

export const beBeeServiceAddSavedRow = (idList, data) => {
  const url = endpoints.addSavedRow(idList)
  return apiWrapper({
    method: 'post',
    url: url,
    data: JSON.stringify(data)
  }).then(res => res.data)
}

export const beBeeGetSavedRows = (idList, idCategory) => {
  const url = endpoints.getSavedRows(idList, idCategory)

  return apiWrapper({
    method: 'get',
    url: url
  }).then(res => res.data)
}

export const beBeeCountSavedRows = (idList, idCategory) => {
  const url = endpoints.countSavedRows(idList, idCategory)

  return apiWrapper({
    method: 'get',
    url: url
  }).then(res => res.data)
}

export const beBeeGetSavedRow = (idList, idSavedRow) => {
  const url = endpoints.getSavedRow(idList, idSavedRow)

  return apiWrapper({
    method: 'get',
    url: url
  }).then(res => res.data)
}

export const beBeeDeleteSavedRows = (idList, idSavedRow) => {
  const url = endpoints.deleteSavedRows(idList, idSavedRow)

  return apiWrapper({
    method: 'delete',
    url: url
  }).then(res => res.data)
}

export const beBeeUpdateSavedRows = (idList, idSavedRow, data) => {
  const url = endpoints.updateSavedRows(idList, idSavedRow)

  return apiWrapper({
    method: 'put',
    url: url,
    data: JSON.stringify(data)
  }).then(res => res.data)
}

export const beBeeServiceApiAuthorizeBee = async page => {
  return await apiWrapper({
    method: 'get',
    url: endpoints.authorizeBee(page)
  }).then(res => res.data)
}
